import SecurityIcon from './SecurityIcon'

export default SecurityIcon
